import * as Tooltip from '@radix-ui/react-tooltip';

import { styled } from '@lichtblick/styled';
import { Spacing, Colors } from '@lichtblick/theme';

export const TooltipContent = styled(Tooltip.Content)`
  align-items: center;
  animation-duration: 400ms;
  animation-name: slideDownAndFade;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  background-color: ${Colors.gray[50]};
  border-radius: 0.25rem;

  display: flex;
  height: 1.5rem;
  letter-spacing: 0.0313rem;

  margin-bottom: ${Spacing.Xxs};
  padding: 0 ${Spacing.Xxs};

  @keyframes slideDownAndFade {
    from {
      opacity: 0;
      transform: translateY(-0.125rem);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
